<template>
  <v-app id="app">
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-list dense>
        <v-list-item link @click="$router.push('/')">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="createList">
          <v-list-item-action>
            <v-icon>mdi-pencil</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Create a new list</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="indigo"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-icon @click="$router.push('/')">mdi-cart</v-icon>
      <v-toolbar-title @click="$router.push('/')">ShopList</v-toolbar-title>

      <v-spacer />
      <FindList :always-show="false" />
      <v-spacer />
    </v-app-bar>

    <v-content>
      <v-content>
        <v-container
          class="fill-height"
          fluid
          >
          <v-row
            align="center"
            justify="center"
            >
            <v-col class="text-center">
              <router-view />
            </v-col>
          </v-row>
        </v-container>
      </v-content>

    </v-content>
  </v-app>
</template>

<script>
import FindList from './components/FindList.vue'

export default {
  props: {
    source: String,
  },
  components: {
    FindList
  },
  data: () => ({
    drawer: null,
  }),
  methods: {
    createList () {
      this.$http.put(
        `https://api.shoplist.peuvrel.net/list`
      ).then((response) => {
        const rep = JSON.parse(response.data.data)
        this.$router.push(`/list/${rep.id}`)
      });
    },
  },
}
</script>
